import classNames from 'classnames';
import React from 'react';

import {
    GwgCarousel,
    GwgAccelerator,
    AcademySelected,
    AcademyPresented,
} from '@udemy/career-academies';
import {Tracker, TrackImpression} from '@udemy/event-tracking';
import {FeatureVariantAssignment} from '@udemy/graphql';
import {SubscriptionPlanSubscriberState} from '@udemy/subscription-graphql';

import styles from '../topic.module.less';
import {type BundleVariant, type Topic as TopicType} from '../types/topic';
import {TopicBundleUnit} from './topic-bundle-unit.react-component';

interface TopicStaticUnitsProps {
    showGwgCarousel?: boolean;
    gwgCarouselAccelerator?: GwgAccelerator;
    activeSubscriptionPlan?: SubscriptionPlanSubscriberState;
    bundleVariant: BundleVariant | null;
    topicId: TopicType['id'];
    isTopicVoucherModuleAboveBundle?: FeatureVariantAssignment;
    isMobile?: boolean | null;
    topicCatSubcatMwebCardStandardizationFeature?: FeatureVariantAssignment;
    /** When true (from TopicWrapper), generic bundle uses large vertical product cards — same gate as discovery */
    useVerticalRecoCourseCardStyle?: boolean;
    isExperimentConfigsLoading?: boolean;
}

export const TopicStaticUnits: React.FC<TopicStaticUnitsProps> = ({
    showGwgCarousel,
    gwgCarouselAccelerator,
    activeSubscriptionPlan,
    bundleVariant,
    topicId,
    isTopicVoucherModuleAboveBundle,
    isMobile,
    topicCatSubcatMwebCardStandardizationFeature,
    useVerticalRecoCourseCardStyle,
    isExperimentConfigsLoading,
}) => (
    <>
        {showGwgCarousel && gwgCarouselAccelerator && (
            <div className={classNames(styles['gwg-unit-wrapper'], 'component-margin')}>
                <div className={classNames('ud-heading-xl', styles['gwg-unit-header'])}>
                    {gettext('Learn AI with Google')}
                </div>
                <TrackImpression
                    trackFunc={() => {
                        Tracker.publishEvent(
                            new AcademyPresented({
                                academySlug: gwgCarouselAccelerator.slug ?? '',
                                uiRegion: 'learn-ai-with-google',
                            }),
                        );
                    }}
                >
                    <div>
                        <GwgCarousel
                            accelerator={gwgCarouselAccelerator}
                            currentlySubscribedPlan={activeSubscriptionPlan}
                            onEnrollmentClick={() => {
                                Tracker.publishEvent(
                                    new AcademySelected({
                                        academySlug: gwgCarouselAccelerator.slug ?? '',
                                        uiRegion: 'learn-ai-with-google',
                                    }),
                                );
                            }}
                        />
                    </div>
                </TrackImpression>
            </div>
        )}
        {bundleVariant && (
            <TopicBundleUnit
                variant={bundleVariant}
                topicId={topicId}
                isTopicVoucherModuleAboveBundle={isTopicVoucherModuleAboveBundle}
                isMobile={isMobile}
                topicCatSubcatMwebCardStandardizationFeature={
                    topicCatSubcatMwebCardStandardizationFeature
                }
                useVerticalRecoCourseCardStyle={useVerticalRecoCourseCardStyle}
                isExperimentConfigsLoading={isExperimentConfigsLoading}
            />
        )}
    </>
);
